import { useContext } from "react";

import { LoggedInAdminContext } from "src/components/LoggedInAdminProvider";
import { loggedInInfo_loggedInInfo_tenant_featureFlags } from "src/graphql/generated/loggedInInfo";

export type Flag = keyof Omit<
  loggedInInfo_loggedInInfo_tenant_featureFlags,
  "__typename"
>;

export function useFeatureFlag(flag: Flag): boolean {
  const { loggedInInfo } = useContext(LoggedInAdminContext);
  return loggedInInfo?.tenant.featureFlags[flag] ?? false;
}
